<template>
  <v-app>
    <MaintenanceBanner />
    <Navigation />
    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <Footer />

    <v-snackbar
      v-model="error.value"
      color="error"
      :timeout="-1"
      :top="true"
      v-if="!error.stream"
    >
      error {{ error.code }} {{ error.message }}
      <v-btn
        dark
        text
        @click="clearError()"
      >
      <!-- @click="error.value = false" -->
      <!-- @click="$router.go()" -->
        Close
      </v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="error.stream"
      color="error"
      :timeout="-1"
      :top="true"
    >
      Connection lost
      <v-btn
        dark
        text
        @click="tryAgain()"
      >
        Try Again
      </v-btn>
    </v-snackbar>

  </v-app>
</template>

<script>
import auth from "@/auth/authService";
import Navigation from '@/components/Navigation.vue'
import Footer from '@/components/Footer.vue'
import MaintenanceBanner from '@/components/MaintenanceBanner.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: { Navigation, Footer, MaintenanceBanner },
  computed: mapGetters(['error']),
  data: () => ({
  }),
  created() {
    auth.renewTokens().then(() => {
      this.fromContext();
      //this.watchImages();
      this.filterImages();
    });
  },
  methods: {
    tryAgain() {
      auth.renewTokens().then(() => {
        this.clearError();
        //this.watchImages();
        this.filterImages();
      });
    },
    //...mapActions(['fromContext', 'filterImages', 'watchImages', 'clearError'])
    ...mapActions(['fromContext', 'filterImages', 'clearError'])
  }
}
</script>

<style>
 .v-tabs__content {
   padding-bottom: 2px;
 }
 table tbody tr {
  border: 0px solid black !important;
}
 tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .02);
}
/* .v-icon {
  display: inline-flex !important;
} */
</style>
